import apiService from './apiService';

interface LoginRequest {
  username: string;  // Changed from 'email' to 'username'
  password: string;
}

interface LoginResponse {
  token: string;
  refreshToken: string;
  // The user information might be extracted from the token
  // If the backend doesn't return user info directly
}

export const loginApi = async (credentials: LoginRequest): Promise<LoginResponse> => {
  const response = await apiService.post<LoginResponse>('/auth/login', credentials);
  return response.data;
};

export const logoutApi = async (): Promise<void> => {
  await apiService.post('/auth/logout');
};

interface RefreshTokenRequest {
  refreshToken: string;
}

interface RefreshTokenResponse {
  token: string;
  refreshToken?: string; // Some APIs also return a new refresh token
}

export const refreshTokenApi = async (refreshToken: string): Promise<RefreshTokenResponse> => {
  const response = await apiService.post<RefreshTokenResponse>('/auth/refresh', { refreshToken });
  return response.data;
};